import { render, staticRenderFns } from "./CategoriseContent.view.vue?vue&type=template&id=70f4f8e3&scoped=true"
import script from "./CategoriseContent.view.vue?vue&type=script&lang=js"
export * from "./CategoriseContent.view.vue?vue&type=script&lang=js"
import style0 from "./CategoriseContent.view.vue?vue&type=style&index=0&id=70f4f8e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f4f8e3",
  null
  
)

export default component.exports